<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M9,9C8.586,9,8.25,8.664,8.25,8.25v-1.5C8.25,6.336,8.586,6,9,6s0.75,0.336,0.75,0.75v1.5C9.75,8.664,9.414,9,9,9z"/>
	<path d="M15,9c-0.414,0-0.75-0.336-0.75-0.75v-1.5C14.25,6.336,14.586,6,15,6s0.75,0.336,0.75,0.75v1.5C15.75,8.664,15.414,9,15,9z
		"/>
	<path d="M12,24c-4.166,0-5.662-3.705-7.362-12H3.75C3.336,12,3,12.336,3,12.75v3.879c0.885,0.313,1.5,1.161,1.5,2.121v1.5
		C4.5,20.664,4.164,21,3.75,21S3,20.664,3,20.25v-1.5C3,18.336,2.664,18,2.25,18S1.5,18.336,1.5,18.75v1.5
		C1.5,20.664,1.164,21,0.75,21S0,20.664,0,20.25v-1.5c0-0.96,0.615-1.808,1.5-2.121V12.75c0-1.241,1.009-2.25,2.25-2.25H4.5v-3
		C4.5,3.365,7.865,0,12,0s7.5,3.365,7.5,7.5v3h0.75c1.241,0,2.25,1.009,2.25,2.25v3.879c0.885,0.314,1.5,1.162,1.5,2.121v1.5
		c0,0.414-0.336,0.75-0.75,0.75s-0.75-0.336-0.75-0.75v-1.5c0-0.414-0.336-0.75-0.75-0.75S21,18.336,21,18.75v1.5
		c0,0.414-0.336,0.75-0.75,0.75s-0.75-0.336-0.75-0.75v-1.5c0-0.96,0.615-1.808,1.5-2.121V12.75c0-0.414-0.336-0.75-0.75-0.75
		h-0.887C17.667,20.295,16.172,24,12,24z M6.169,12C8.039,20.97,9.493,22.5,12,22.5c2.512,0,3.967-1.53,5.832-10.5H6.169z M18,10.5
		v-3c0-3.308-2.692-6-6-6c-3.308,0-6,2.692-6,6v3H18z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'robot-2',
    },
    name: {
      type: String,
      required: false,
      default: 'Robot2',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>